import { useGlobal } from '@/utils/useGlobal';

export default function IndexPc({ cards }: any) {
    const { useLang, useEffect } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');

    return (
        <div className="container">
            <div className="left">
                <p className="title">{t('dg200.cardsIconJ_title')}</p>
                <p className="desc">{t('dg200.cardsIconJ_desc')}</p>
                <div className="after"></div>
            </div>
            <div className="right">
                {cards?.map((card: any, k: number) => (
                    <div className={`card ${k === cards?.length - 1 ? 'lastCard' : ''}`} key={k}>
                        <div className="cardIcon">{card?.icon}</div>
                        <p className="cardTitle">{card?.title}</p>
                        <p className="cardText">{card?.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
